<ng-container *ngIf="week !== null && isoYear !== null">
  <p class="mt-1">{{ 'WEEK_NUMBER.MESSAGE' | translate: { week: week, year: isoYear } }}</p>
</ng-container>
